
import * as ActionTypes from "./actionTypes";



export function clearErrors() {
    return { type: ActionTypes.CLEAR_ERROR, payload: null };
}


